export const trackPageView = () => {
    if (window.fbq) {
        window.fbq('track', 'PageView');
    }
};

export const trackCompleteRegistration = () => {
    if (window.fbq) {
        window.fbq('track', 'CompleteRegistration');
    }
};